import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useVideoDetails from './UseVideoDetails';
import VideoTrimmer from './VideoTrimmer';
import styled from 'styled-components';

const VideoTrimmerWrapper = () => {
  const { videoId } = useParams();
  const navigate = useNavigate();
  const { videoDetails, isLoading, error } = useVideoDetails(videoId);

  const handleClose = () => {
    navigate('/explore');
  };

  if (isLoading) {
    return <LoadingMessage>Loading video details...</LoadingMessage>;
  }

  if (error) {
    return <ErrorMessage>{error}</ErrorMessage>;
  }

  if (!videoDetails) {
    return <ErrorMessage>Video not found</ErrorMessage>;
  }

  // Transform videoDetails to match VideoTrimmer's expected video prop structure
  const video = {
    id: videoDetails.id,
    preSignedS3Url: videoDetails.preSignedS3Url,
    duration: videoDetails.duration,
    title: videoDetails.title || `Video ${videoDetails.id}`,
  };

  return <VideoTrimmer video={video} onClose={handleClose} />;
};

export default VideoTrimmerWrapper;

const LoadingMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
`;

const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: red;
  text-align: center;
`;
